import { RadioGroup, Span } from '@pcln/horizon'

type FormTypeRadios = {
  formType: string
  onChange: (selectedFormName: string) => void
}

const isString = (value: unknown): value is string => {
  return typeof value === 'string'
}

export default function FormTypeRadios({ formType, onChange }: FormTypeRadios) {
  const handleChange = (value: unknown) => {
    if (isString(value)) {
      onChange(value)
    }
  }

  return (
    <div className="flex">
      <RadioGroup
        className="flex flex-row gap-4"
        aria-labelledby="hotel-search-type"
        defaultValue={formType}
        handleChange={handleChange}
        name="hotelSearchType"
        options={[
          {
            disabled: false,
            labelNode: <Span className="whitespace-nowrap">Single Hotel</Span>,
            name: 'hotelSearchType',
            size: '16',
            value: 'single'
          },
          {
            disabled: false,
            labelNode: <Span className="whitespace-nowrap">Multi-hotel</Span>,
            name: 'hotelSearchType',
            size: '16',
            value: 'multi'
          }
        ]}
      />
    </div>
  )
}
